{
  "chart": {
    "empty": {
      "description": "No hay datos disponibles para este período.",
      "title": "No se han encontrado datos"
    }
  },
  "date_picker": {
    "all_time": "Todo el período",
    "confirm": "Confirmar",
    "current_quarter": "Trimestre actual",
    "date_range": "{startDate} - {endDate}",
    "last_n_days": "Últimos {days} días",
    "last_n_months": "Últimos {months} meses",
    "last_quarter": "Trimestre anterior",
    "last_year": "Año pasado",
    "lifetime": "Todo el período",
    "this_year": "Este año",
    "today": "Hoy"
  },
  "document_viewer": {
    "sidebar_heading": "Resumen del contenido"
  },
  "dynamic_keys": {
    "saml": {
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    }
  },
  "editor": {
    "placeholder": "Escribe algo",
    "placeholder_with_options": "Escribe o introduce '/' para ver las opciones"
  },
  "error": {
    "title": "Se ha producido un error."
  },
  "factor_indicator": {
    "average": "Medio",
    "bad": "Crítico",
    "excellent": "Excelente",
    "good": "Bueno"
  },
  "gauge_chart": {
    "empty": {
      "title": "No hay datos disponibles",
      "tooltip": "Se está calculando tu puntuación de resiliencia"
    }
  },
  "locale": {
    "current": "Español",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "saml_provider_button": {
    "continue_with": "Continuar con {provider}"
  },
  "search": {
    "no_options": "No hay opciones disponibles.",
    "no_results": "No se han encontrado resultados.",
    "placeholder": "Buscar..."
  },
  "simulations": {
    "expand_preview": {
      "close": "Cerrar vista previa",
      "open": "Ampliar vista previa"
    }
  },
  "video_player": {
    "captions": "Subtítulos",
    "captions_off": "Desactivados",
    "normal_speed": "Normal",
    "playback_speed": "Velocidad de reproducción"
  }
}
